module.exports = __webpack_public_path__ + "img/img_finished_sign_up.589eec81.svg";